import { Icon } from '@/shared'
import { EIcons } from '@App/types/iconType'
import { onUseAnchor } from '@App/utils'

import style from './Anchors.module.scss'

interface IProps {
    anchors: IAnchors[]
}

interface IAnchors {
    title: string
    id: string
}

export const Anchors = (props: IProps) => {
    const { anchors } = props
    return (
        <div className={style.container}>
            <div className={style.arrow}>
                <Icon iconName={EIcons.AROW} />
            </div>
            <div className={style.itemsWrapper}>
                {anchors.map((anchor) => {
                    const { title, id } = anchor
                    const onHandleClick = () => onUseAnchor(id)
                    return (
                        <div key={id} className={style.item} onClick={onHandleClick}>
                            <span>{title}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
